// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import config from "../../config";

// function AddNewBlog() {
//   const navigate = useNavigate();
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: '',
//     location: '',
//     featuredImage: null,
//   });

//   const handleInputChange = async (e) => {
//     const { name, value, files } = e;

//     setFormData((prevData) => ({
//         ...prevData,
//         [name]: files ? files : value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const data = new FormData();
//     data.append('title', formData.title);
//     data.append('location', formData.location);
    
//     if (formData.featuredImage) {
//       data.append('featuredImage', formData.featuredImage[0]);
//     }

//     try {
//       const response = await axios.post(`${config.BASE_URL}/api/admin/add-portfolio`, data, {
//         withCredentials: true,
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       if (response.status === 200) {
//         const token = localStorage.getItem('token');
//         if (token) {
//           navigate('/admin/portfolios');
//         } else {
//           navigate('/admin/login');
//         }
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to add portfolio');
//     }
//   };
//   return (
//     <div className="dashboard">
//       <div className="container">
//         <h1 className="dash_title">Dashboard</h1>
//         <div className="main-section">
//           <div className="back_btn_wrap">
//             <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//           </div>
//           <div className="main-inner add_project_main">
//             <form onSubmit={handleSubmit} encType="multipart/form-data">
//               <div className="form-login">
//                 <div className="add_field titleField">
//                   <h2>Title</h2>
//                   <input
//                     type="text"
//                     name="title"
//                     value={formData.title}
//                     onChange={(e) => handleInputChange(e.target)}
//                     required
//                   />
//                 </div>

//                 <div className="add_field textareaField">
//                   <h2>Location</h2>
//                   <textarea
//                     name="location"
//                     value={formData.location}
//                     onChange={(e) => handleInputChange(e.target)}
//                     required
//                   />
//                 </div>

//                 <div className="add_field">
//                   <h2>Featured Image</h2>
//                   <div className="form-group">
//                     <div className="file-upload">
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="featuredImage"
//                         onChange={(e) => handleInputChange(e.target)}
//                         required
//                       />
//                       <i className="fa fa-camera i-pic-upload"></i>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="add_project">
//                 <button type="submit">Add Portfolio</button>
//               </div>

//             </form>
//             {error && <p className="error-message">{error}</p>}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AddNewBlog;





import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function AddNewPortfolio() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [activeLanguage, setActiveLanguage] = useState('en');

  // Main form data for English (default)
  const [formData, setFormData] = useState({
    language: 'en',
    title: '',
    location: '',
    // slug: '',
    featuredImage: null,
  });

  // Spanish translation data
  const [spanishData, setSpanishData] = useState({
    language: 'es',
    title: '',
    location: '',
  });

  // Handle language tab switching
  const switchLanguage = (lang) => {
    setActiveLanguage(lang);
  };

  // Main form handlers (English)
  const handleInputChange = async (e) => {
    const { name, value, files } = e;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files : value
    }));
  };

  // Spanish form handlers
  const handleSpanishInputChange = (e) => {
    const { name, value } = e.target;
    setSpanishData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    
    // Main English data
    data.append('language', formData.language);
    data.append('title', formData.title);
    data.append('location', formData.location);
    // data.append('slug', formData.slug);

    // Spanish translation data
    data.append('spanishData', JSON.stringify(spanishData));
    
    // File upload (shared between languages)
    if (formData.featuredImage) {
      data.append('featuredImage', formData.featuredImage[0]);
    }

    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/add-portfolio`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        const token = localStorage.getItem('token');
        if (token) {
          navigate('/admin/portfolios');
        } else {
          navigate('/admin/login');
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add portfolio');
    }
  };

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Dashboard</h1>
        <div className="main-section">
          <div className="back_btn_wrap">
            <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
          </div>
          <div className="main-inner add_project_main">
            
            {/* Language Tabs */}
            <div className="language-tabs" style={{ marginBottom: '20px' }}>
              <button 
                type="button" 
                className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                onClick={() => switchLanguage('en')}
                style={{
                  padding: '10px 20px',
                  marginRight: '10px',
                  backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'en' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                English
              </button>
              <button 
                type="button" 
                className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                onClick={() => switchLanguage('es')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'es' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                Spanish
              </button>
            </div>

            <form onSubmit={handleSubmit} encType="multipart/form-data">
              
              {/* English Content */}
              {activeLanguage === 'en' && (
                <div className="language-content">
                  <h3>English Content</h3>
                  
                  <div className="form-login">
                    <div className="add_field titleField">
                      <h2>Title (English)</h2>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                    </div>

                    {/* <div className="add_field titleField">
                      <h2>Slug (English)</h2>
                      <input
                        type="text"
                        name="slug"
                        value={formData.slug}
                        onChange={(e) => handleInputChange(e.target)}
                        placeholder="url-friendly-slug"
                        required
                      />
                    </div> */}

                    <div className="add_field textareaField">
                      <h2>Location (English)</h2>
                      <textarea
                        name="location"
                        value={formData?.location}
                        onChange={(e) => handleInputChange(e.target)}
                        rows="4"
                        placeholder="Enter portfolio location or description"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Spanish Content */}
              {activeLanguage === 'es' && (
                <div className="language-content">
                  <h3>Spanish Content</h3>
                  
                  <div className="form-login">
                    <div className="add_field titleField">
                      <h2>Title (Spanish)</h2>
                      <input
                        type="text"
                        name="title"
                        value={spanishData.title}
                        onChange={handleSpanishInputChange}
                        placeholder="Título en español"
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Location (Spanish)</h2>
                      <textarea
                        name="location"
                        value={spanishData?.location}
                        onChange={handleSpanishInputChange}
                        rows="4"
                        placeholder="Ingrese la ubicación o descripción del portafolio"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Shared Fields - Always Visible */}
              <div className="shared-fields">
                <div className="add_field">
                  <h2>Featured Image</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="featuredImage"
                        onChange={(e) => handleInputChange(e.target)}
                        accept="image/*"
                        required
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                  <small style={{ color: '#666', fontSize: '12px' }}>
                    This image will be shared across all language versions
                  </small>
                </div>
              </div>

              <div className="add_project">
                <button type="submit">Add Portfolio</button>
              </div>

            </form>
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewPortfolio;